import { select, scaleBand, scaleLinear } from 'd3';
import _ from 'lodash';
import text from '../../data/text.json';

// setup
const container = select('#graphic__mileage');
const params = {
  size: {
    w: container.node().clientWidth,
    h: 160,
  },
  margin: { t: 0, r: 0, b: 7, l: 95 },
};

// data
const data = [
  {
    label: ['Texas-Mexico', 'border'],
    mileage: 1254,
    start: 0,
    color: 'black',
    align: 'end',
    anchor: 1254,
  },
  {
    label: ['Miles of', 'natural barriers'],
    mileage: 180,
    start: 0,
    color: '#66989e',
    align: 'middle',
    anchor: 90,
  },
  {
    label: ['Miles of existing', 'federal wall'],
    mileage: 140,
    start: 180,
    color: '#4f1200',
    align: 'middle',
    anchor: 250,
  },
  {
    label: ['Miles of state', 'wall completed'],
    mileage: 50,
    start: 320,
    color: '#ff3d00',
    align: 'start',
    anchor: 335,
  },
];

const drawChart = () => {
  const svg = container
    .append('svg')
    .attr('width', params.size.w)
    .attr('height', params.size.h);

  // alt text
  svg
    .attr('role', 'img')
    .append('title')
    .text(text['graphic_1-1'][0]['embed_alt_text']);

  // scales
  const xScale = scaleLinear()
    .domain([0, 1254])
    .range([params.margin.l, params.size.w - params.margin.r]);
  const yScale = scaleBand()
    .domain(data.map(d => d.label))
    .range([params.margin.t, params.size.h - params.margin.b]);

  // highlight
  const highlight = svg.append('g').attr('class', 'highlight');
  highlight
    .append('rect')
    .attr('x', xScale(320))
    .attr('y', 45)
    .attr('width', xScale(805) - params.margin.l)
    .attr('height', 72)
    .attr('fill', '#D3D3D3')
    .attr('fill-opacity', 0.66);
  highlight
    .append('rect')
    .attr('x', xScale(320))
    .attr('y', 45)
    .attr('width', xScale(805) - params.margin.l)
    .attr('height', 72)
    .attr('fill', 'url(#diagonalHatch)');
  const annotationBuffer = highlight
    .append('g')
    .attr('class', 'annotation-buffer')
    .attr('transform', `translate(${xScale(722.5)}, 70)`);
  annotationBuffer
    .append('text')
    .attr('dx', 0)
    .attr('dy', 0)
    .html(`Texas wants to`);
  annotationBuffer
    .append('text')
    .attr('dx', 0)
    .attr('dy', 15)
    .html(`build 805 miles`);
  annotationBuffer
    .append('text')
    .attr('dx', 0)
    .attr('dy', 30)
    .html(`of border wall`);
  const annotation = highlight
    .append('g')
    .attr('class', 'annotation')
    .attr('transform', `translate(${xScale(722.5)}, 70)`);
  annotation
    .append('text')
    .attr('dx', 0)
    .attr('dy', 0)
    .html(`Texas wants to`);
  annotation
    .append('text')
    .attr('dx', 0)
    .attr('dy', 15)
    .html(`build 805 miles`);
  annotation
    .append('text')
    .attr('dx', 0)
    .attr('dy', 30)
    .html(`of border wall`);

  // axes
  const axes = svg.append('g').attr('class', 'axes');

  // y axis
  axes
    .selectAll('g.tick')
    .data(data)
    .join('g')
    .attr('class', 'tick')
    .attr(
      'transform',
      (d, i) =>
        `translate(
          ${params.margin.l - 6},
          ${yScale(d.label) + yScale.bandwidth() / 2}
        )`
    )
    .style('fill', d => d.color)
    .each(function() {
      const dat = select(this).data()[0];
      select(this)
        .selectAll('text')
        .data(dat.label)
        .join('text')
        .attr('dx', 0)
        .attr('dy', (d, i) => i * 14)
        .text(d => d);
    });

  // x axis
  axes
    .append('line')
    .attr('x1', params.margin.l)
    .attr('x2', params.margin.l)
    .attr('y1', params.margin.t)
    .attr('y2', params.size.h)
    .attr('stroke-width', 1)
    .attr('stroke', 'black');
  axes
    .append('line')
    .attr('x1', xScale(180))
    .attr('x2', xScale(180))
    .attr('y1', params.margin.t)
    .attr('y2', params.size.h)
    .attr('stroke-width', 1)
    .attr('stroke', 'black')
    .attr('stroke-linecap', 'round')
    .attr('stroke-dasharray', '2 4');
  axes
    .append('line')
    .attr('x1', xScale(180 + 140))
    .attr('x2', xScale(180 + 140))
    .attr('y1', params.margin.t)
    .attr('y2', params.size.h)
    .attr('stroke-width', 1)
    .attr('stroke', 'black')
    .attr('stroke-linecap', 'round')
    .attr('stroke-dasharray', '2 4');

  // bars
  const bars = svg
    .append('g')
    .attr('class', 'bars')
    .selectAll('g.bar')
    .data(data)
    .join('g')
    .attr('class', 'bar')
    .attr('transform', `translate(0, ${yScale.bandwidth() / 2 + 5})`);

  bars.each(function() {
    const dat = select(this).data()[0];
    select(this)
      .append('line')
      .attr('x1', xScale(dat.start))
      .attr('x2', xScale(dat.start + dat.mileage))
      .attr('y1', yScale(dat.label))
      .attr('y2', yScale(dat.label))
      .attr('stroke', dat.color)
      .attr('stroke-width', 4);
    select(this)
      .append('text')
      .attr('x', xScale(dat.anchor))
      .attr('y', yScale(dat.label) - 5)
      .attr('text-anchor', dat.align)
      .attr('fill', dat.color)
      .text(dat.mileage == 1254 ? '1,254 miles' : dat.mileage);
  });
};

const resize = () => {
  container.select('svg').remove();
  params.size.w = container.node().clientWidth;
  drawChart();
};

// call resize on load
resize();
window.addEventListener('resize', _.debounce(resize, 200));



